var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center pa-4"},[_c('v-dialog',{attrs:{"width":"auto","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }